import React from "react";
import { shallowEqual } from "react-redux";

import HeadwayPerformanceMapBuses from "./HeadwayPerformanceMapBuses";
import { useAppSelector } from "../../redux/hooks";
import { getHeadwayCategoryBuses } from "../../utils/swiftlyHelpers";
import { RemainingBusesIcons } from "../MapComponent";

const HeadwayPerformanceMap = ({
  buses,
  showLineNumbers,
}: {
  buses: {
    busesOnTime: BusInfo[];
    busesTooFast: BusInfo[];
    delayedBuses: BusInfo[];
    remainingBuses: BusInfo[];
    busesWithLayover: BusInfo[];
  };
  showLineNumbers: boolean;
}): JSX.Element => {
  const [headwayDeviationCategory, filterByRouteId]: [string, string] = useAppSelector(
    (state: RootState) => [state?.swiftly?.headwayDeviationCategory, state?.mapView?.filterByRouteId],
    shallowEqual
  );
  // console.log("filterByRouteId:", filterByRouteId);

  const [headwayBuses, setHeadwayBuses] = React.useState<BusInfo[] | null>(null);
  const [remainingBuses, setRemainingBuses] = React.useState<BusInfo[] | null>(null);

  React.useEffect(() => {
    const remainingBusesToShow: BusInfo[] = buses?.remainingBuses; //* Unassigned buses -> [] as BusInfo[] in App.tsx!
    // console.log("remainingBusesToShow:", remainingBusesToShow);
    setRemainingBuses(remainingBusesToShow);

    const allWorkingBuses: BusInfo[] = ([] as BusInfo[])
      .concat(buses?.busesOnTime, buses?.busesTooFast, buses?.delayedBuses, buses?.busesWithLayover)
      ?.filter((elem: BusInfo) => elem !== undefined);
    // console.log("allWorkingBuses:", allWorkingBuses);

    let busesToSet: BusInfo[] = getHeadwayCategoryBuses(headwayDeviationCategory, allWorkingBuses);

    //* Filter buses by routeId
    if (filterByRouteId) {
      busesToSet =
        filterByRouteId === "allRoutes" || !filterByRouteId
          ? [...busesToSet]
          : busesToSet?.filter((bus: BusInfo) => bus?.routeId === filterByRouteId);
      // console.log("filteredBusesTogether:", filteredBusesTogether);
    }

    setHeadwayBuses(busesToSet);
  }, [buses, filterByRouteId, headwayDeviationCategory]);

  return (
    <React.Fragment>
      {headwayBuses ? (
        <HeadwayPerformanceMapBuses workingBusesToShow={headwayBuses} showLineNumbers={showLineNumbers} />
      ) : null}
      {remainingBuses ? <RemainingBusesIcons remainingBuses={remainingBuses} showLineNumbers={showLineNumbers} /> : null}
    </React.Fragment>
  );
};

export default HeadwayPerformanceMap;
